<div style="width: 100vw; height: fit-content;">
  <div *ngIf="isCustomPopoverOpen === true" class="custom-popover" (click)="onPopoverClick($event)">
    <div class="popover-item" *ngFor="let user of users" (click)="selectUser(user, searchAreaSelected)">
      {{ user.userName }}
    </div>
  </div>
</div>